/**
 * @format
 * @flow
 */
export const SIGNED_UP = "SIGNED_UP";
export const LOGGED_IN = "LOGGED_IN";
export const RESET = "RESET";
export const LOGGED_OUT = "LOGGED_OUT";
export const UPDATED_USER = "UPDATED_USER";
